import { IApprovalProccessId } from "../../../types"
import { getApprovalActorAccess } from "../../shared/utils/approvalAccess"

interface IProductEditAccess {
  isApprover: boolean
  isPic: boolean
  canEdit: boolean
}

export const getProductEditAccess = (
  approvalProcess: IApprovalProccessId | null | undefined,
  employeeId: string | null | undefined,
): IProductEditAccess => {
  const approvalAccess = getApprovalActorAccess(approvalProcess, employeeId)

  return {
    isApprover: approvalAccess.isApprover,
    isPic: approvalAccess.isPic,
    canEdit: approvalAccess.isApprover || approvalAccess.isPic,
  }
}
